import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const shortcuts = [
  {
    label: 'Consulter les archives',
    description: 'Parcourir les documents archivés',
    icon: 'ri-archive-line',
    path: '/apps/in/archives',
    requiresAuth: true,
  },
  {
    label: 'Rechercher une archive',
    description: 'Retrouver un document rapidement',
    icon: 'ri-search-2-line',
    path: '/apps/in/archives/search',
    requiresAuth: true,
  },
  {
    label: 'Importer des archives',
    description: 'Déposer des documents en lot',
    icon: 'ri-upload-2-line',
    path: '/apps/in/archives/import',
    requiresAuth: true,
  },
  {
    label: 'Plan de classement',
    description: 'Explorer les dossiers et sous-dossiers',
    icon: 'ri-folder-5-line',
    path: '/apps/in/plan-classement',
    requiresAuth: true,
  },
  {
    label: 'Guide utilisateur',
    description: 'Découvrir les étapes et les outils',
    icon: 'ri-book-open-line',
    path: '/guide-utilisateur',
  },
  {
    label: 'Nous contacter',
    description: 'Joindre le support technique',
    icon: 'ri-customer-service-2-line',
    path: '/contacts',
  },
];

const HomeQuickLinks = () => {
  const session = useSelector((state) => state.sessionAuth);
  const isAuthenticated = Boolean(
    session?.isAuthenticated && session?.token && session.token !== 'expired'
  );

  return <section className="home-shortcuts" aria-label="Accès direct aux fonctionnalités">
    <div className="container">
      <div className="home-shortcuts-heading">
        <span className="home-section-eyebrow">ACCÈS DIRECT</span>
        <p>Accédez directement aux principales fonctionnalités de Syidocs archivage.</p>
      </div>
      <div className="home-shortcuts-grid">
        {shortcuts.map(({ label, description, icon, path, requiresAuth }) => (
          <Link className="home-shortcut" to={requiresAuth && !isAuthenticated ? '/login' : path} key={path}>
            <span className="home-shortcut-icon" aria-hidden="true">
              <i className={icon} />
            </span>
            <span className="home-shortcut-label">{label}</span>
            <span className="home-shortcut-description">{description}</span>
          </Link>
        ))}
      </div>
    </div>
  </section>;
};

export default HomeQuickLinks;
